<script>
    export default {
        name: "widgets-header",
        props: {
            count: {},
        },
        computed: {
            translations() {
                return {
                    title: Lang.langChoice("Widget|Widgets", 2),
                }
            },
            title() {
                if (_.isUndefined(this.count)) return `${this.translations.title}`;
                return `${this.translations.title} (${this.count})`;
            }
        }
    }
</script>

<template>
    <div>
        <h1>{{ title }}</h1>
        <div class="mt-8 d-flex flex-row flex-wrap">
            <slot/>
        </div>
    </div>
</template>

<style scoped>

</style>
